import { useWallets } from "api/wallets";
import { Breadcrumbs, TopHeader } from "components/Header/TopHeader/TopHeader";
import { useMessage } from "hooks/intl";
import { useParams } from "react-router-dom";
import { links } from "utilities/links";
import { useStyles } from "./WalletType.styles";
import { WalletTypeForm } from "./WalletTypeForm";

export function EditWalletType() {
  const { id: walletTypeId } = useParams<{ id: string }>();
  const { useWalletTypeData } = useWallets();
  const { data: walletTypeDetails } = useWalletTypeData(walletTypeId as string);
  const { message } = useMessage();
  const classes = useStyles();

  const breadcrumbs: Breadcrumbs = {
    parent: {
      label: message({ id: "typesOfWallets" }),
      path: links.walletTypesList,
    },
  };

  return (
    <div>
      <TopHeader
        title={
          walletTypeDetails
            ? `${message({ id: "editWallet" })} "${
                walletTypeDetails?.translations?.en?.name
              }"`
            : ""
        }
        clearLink={links.walletTypesList}
        breadcrumbs={breadcrumbs}
      />
      <div className={classes.walletFormContent}>
        {walletTypeDetails ? (
          <WalletTypeForm editMode initialValues={walletTypeDetails} />
        ) : null}
      </div>
    </div>
  );
}
